import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppLanguages } from '../models/models';

const fullDateConfig = 'fullDate';
const EXCLUDED_DATE = '0001-01-01T00:00:00';

@Pipe({
  name: 'localizedDate',
  pure: false
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: any, pattern: string = fullDateConfig): any {
    if (value === EXCLUDED_DATE) {
      return false;
    }

    const datePipe: DatePipe = new DatePipe(
      this.translateService.currentLang ? this.translateService.currentLang : AppLanguages.english
    );
    return datePipe.transform(value, pattern);
  }
}
